package gr.tech.GRAttestation.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.icons.fa.FaCircleArrowLeft
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.components.layouts.PageLayout
import gr.tech.GRAttestation.navigation.SitePage
import gr.tech.GRAttestation.styles.defaultText
import gr.tech.GRAttestation.styles.grstyles.Theme
import gr.tech.GRAttestation.styles.grstyles.buttonColorFadeStyle
import gr.tech.GRAttestation.styles.grstyles.termsListStyle
import gr.tech.GRAttestation.styles.grstyles.termsParagraphStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Page("terms-conditions")
@Composable
fun TermsPage() {
    PageLayout(
        title = "Terms & Conditions",
    ) {
        TermsScreen()
    }
}

@Composable
fun TermsScreen() {
    Box(Modifier.fillMaxSize().backgroundColor(Theme.MediumGreen.rgb), contentAlignment = Alignment.TopCenter) {
        Column(
            modifier = formContainer.toModifier()
        ) {

            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Link(
                    path = SitePage.Dashboard.route
                ) {
                    FaCircleArrowLeft(
                        size = IconSize.XXL,
                        modifier = buttonColorFadeStyle.toModifier()
                    )
                }

                Spacer()
                H1(Modifier.toAttrs {}) {
                    Text("Terms & Conditions")
                }
                Spacer()
            }


            P(attrs = Modifier.toAttrs()) {
                Text("Effective Date: 01/01/2026")
            }

            P(attrs = Modifier.toAttrs()) {
                Text("These Terms govern your use of the Green Rebates portal for the ETO Grow Light Fixture Program. By accessing or using the portal, you agree to these Terms.")
            }

            Ol {
                Li(termsListStyle.toAttrs()) {
                    Text("Authorized Use")
                    P(termsParagraphStyle.toAttrs()) {
                        Text("This portal is intended solely for authorized store representatives participating in the ETO Grow Light Fixture Program. Access is granted by Green Rebates and may be revoked at any time.")
                    }
                }
                Li(termsListStyle.toAttrs()) {
                    Text("Account Responsibility")
                    P(termsParagraphStyle.toAttrs()) {
                        Text("You are responsible for maintaining the confidentiality of your login credentials and for all activity under your account. Notify us immediately of any unauthorized access.")
                    }
                }
                Li(termsListStyle.toAttrs()) {
                    Text("Accuracy of Submissions")
                    P(termsParagraphStyle.toAttrs()) {
                        Text("By submitting an attestation form, you certify that the information provided is accurate and complete. Submission of false or misleading information may result in removal from the program and may have legal consequences.")
                    }
                }
                Li(termsListStyle.toAttrs()) {
                    Text("Prohibited Conduct")
                    P(termsParagraphStyle.toAttrs()) {
                        Text("You agree not to use this portal for any unlawful purpose, attempt to access accounts or data you are not authorized to access, or take any action that disrupts or compromises portal functionality.")
                    }
                }
                Li(termsListStyle.toAttrs()) {
                    Text("Limitation of Liability")
                    P(termsParagraphStyle.toAttrs()) {
                        Text("To the fullest extent permitted by law, Green Rebates LLC shall not be liable for any indirect, incidental, or consequential damages arising from your use of this portal.")
                    }
                }
                Li(termsListStyle.toAttrs()) {
                    Text("Changes and Termination")
                    P(termsParagraphStyle.toAttrs()) {
                        Text("We reserve the right to modify or discontinue the portal at any time. We may suspend or terminate access at our discretion if these Terms are violated.")
                    }
                }
            }

            SpanText(
                text = "© 2026, Green Rebates. All Rights Reserved.",
                modifier = Modifier.defaultText().margin(leftRight = autoLength).fontSize(0.8.cssRem)
            )

            Row(
                modifier = Modifier.fillMaxWidth().gap(16.px),
                horizontalArrangement = Arrangement.Center
            ) {
                Link(
                    path = SitePage.PrivacyPolicy.route,
                    modifier = Modifier.defaultText().color(Theme.DarkGreen.rgb).fontSize(0.8.cssRem)
                ) {
                    Text("Privacy Policy")
                }

                Link(
                    path = SitePage.Dashboard.route,
                    modifier = Modifier.defaultText().color(Theme.DarkGreen.rgb).fontSize(0.8.cssRem)
                ) {
                    Text("Form")
                }
            }
        }
    }
}